<div class="modal-content p-3">
    <div class="modal-body">

        <div class="row">
            <div class="col-sm-12">
                <button class="close mr-4 mt-4" type="button" (click)="close()"><i class="fa fa-times"></i></button>
            </div>
            <div class="col-12">
                <app-alert-message *ngFor="let message of messages; let i = index"
                    [message]="message.text"
                    [isError]="message.isError"
                    [isSuccess]="message.isSuccess"
                    (close)="removeMessage(i)"
                ></app-alert-message>
            </div>

            <div class="col-12" *ngIf="inputModel?.tipoCredencial == 'RUT'">
                <h1>Credenciales Rut</h1>
            </div>

            <div class="col-12" *ngIf="inputModel?.tipoCredencial == 'ORG'">
                <h1>Credenciales Organización</h1>
            </div>

            <ng-container *ngIf="showSpinner; else elseSpinner">
                <div class="col-sm-12 p-5 mt-5">
                    <div class="row">
                        <div class="col-sm-12 d-flex justify-content-center">
                            <div class="spinner-border text-primary" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                        <div class="col-sm-12 text-center mt-1">
                            <span>Cargando...</span>
                        </div>
                    </div>
                </div>
            </ng-container>

            <ng-template #elseSpinner>

                <div class="col-sm-12 mt-3" *ngIf="inputModel?.validCred == 'INVALID' && !credValidada">
                    <div class="info-warning p-1 cursor-pointer" matTooltip="Fecha de Verificación: {{inputModel?.dateStatus ? (inputModel?.dateStatus | date: 'dd-MM-yyyy') : 'No disponible'}}">
                        <p class="text-center text-wrap">
                            Credencial Inválida <mat-icon class="align-middle text-warning" aria-hidden="false" aria-label="info icon" fontIcon="info"></mat-icon>
                        </p>
                    </div>
                </div>

                <div class="col-12 mt-3" *ngIf="inputModel?.tipoCredencial == 'RUT' && inputModel?.rut">
                    <mat-chip-set aria-label="Rut">
                        <mat-chip class="chip-rut"><strong>Rut: </strong>{{inputModel?.rut ? (inputModel?.rut | rutFormat) : ''}}</mat-chip>
                    </mat-chip-set>
                </div>
    
                <div class="col-12 mt-3" *ngIf="servicio?.displayName">
                    <mat-chip-set aria-label="Servicio">
                        <mat-chip class="chip-rut"><strong>Servicio: </strong>{{servicio?.displayName || ''}}</mat-chip>
                    </mat-chip-set>
                </div>

                <div class="col-12" *ngIf="showForm" [formGroup]="configurarForm">
                    <ng-container *ngFor="let atributo of servicio?.attributes; let i = index">
                        <ng-container *ngIf="atributo?.display === true">

                            <div class="row px-3 mt-3">
                                <div class="col-12">
                                    <mat-label><strong> {{atributo?.displayName || ''}}</strong></mat-label>
                                </div>
                                <div class="col-12 pl-4">
                                    <ng-container [ngSwitch]="typeTraduccion(atributo?.typeFormat)">

                                        <ng-container *ngSwitchCase="'boolean'">

                                            <mat-form-field appearance="outline" 
                                                class="min-width" 
                                                [attr.title]="atributo?.name === 'orgAccess' ? 'Desea que todos los usuarios de la organización puedan utilizar esas credenciales o solo el usuario que las crea' : atributo?.displayName || ''">
                                                <mat-select  disableRipple 
                                                    [formControlName]="atributo?.name" 
                                                    [id]="atributo?.name"
                                                >
                                                    <mat-option *ngFor="let option of booleanValueOptions" [value]="option.value">
                                                        {{option.displayName}}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>

                                        </ng-container>

                                        <ng-container *ngSwitchCase="'password'">

                                            <mat-form-field appearance="outline" 
                                                class="min-width" 
                                                [attr.title]="atributo?.name === 'orgAccess' ? 'Desea que todos los usuarios de la organización puedan utilizar esas credenciales o solo el usuario que las crea' : atributo?.displayName || ''">
                                                <input matInput 
                                                    placeholder="{{atributo?.displayName || atributo?.name || ''}}" 
                                                    [id]="atributo.name" 
                                                    [formControlName]="atributo.name" 
                                                    [type]="passControl[atributo.name] ? 'password' : 'text'"
                                                >

                                                <button mat-icon-button matSuffix 
                                                    (click)="passControl[atributo.name] = !passControl[atributo.name]" 
                                                    [attr.aria-label]="'Ocultar contraseña'" 
                                                    [attr.aria-pressed]="passControl[atributo.name]"
                                                >
                                                    <mat-icon>{{passControl[atributo.name] ? 'visibility_off' : 'visibility'}}</mat-icon>
                                                </button>
                                            </mat-form-field>

                                        </ng-container>

                                        <ng-container *ngSwitchDefault>
                                            <mat-form-field appearance="outline" class="min-width">
                                                <input matInput 
                                                    [attr.type]="typeTraduccion(atributo?.typeFormat)"
                                                    [id]="atributo?.name"
                                                    [placeholder]="atributo?.displayName || atributo?.name || ''"
                                                    [formControlName]="atributo?.name"
                                                    [attr.title]="atributo?.name === 'orgAccess' ? 'Desea que todos los usuarios de la organización puedan utilizar esas credenciales o solo el usuario que las crea' : atributo?.displayName || ''"
                                                    [attr.disabled]="atributo?.typeFormat === 'RUT' ? true : null"
                                                >
                                                <button type="button" matSuffix mat-icon-button aria-label="Clear" 
                                                    (click)="configurarForm.get(atributo?.name)?.setValue('')" 
                                                    *ngIf="configurarForm.get(atributo?.name)?.value && atributo?.typeFormat != 'RUT'"
                                                >
                                                    <mat-icon>close</mat-icon>
                                                </button>
                                                
                                            </mat-form-field>
                                        </ng-container>

                                    </ng-container>
                                </div>
                            </div>

                        </ng-container>
                    </ng-container>
                </div>

                <div class="col-12 d-flex justify-content-center align-items-center mt-3" *ngIf="showForm">
                    <ng-container *ngIf="showIcon()">
                        <ng-container *ngIf="credValidada; else elseCredValidada">

                            <mat-icon class="color-tertiary mx-2" 
                                [ngClass]="{'cursor-pointer': iconMensaje}" 
                                [attr.title]="iconMensaje ? iconMensaje : null"
                            >
                                check_circle
                            </mat-icon>


                        </ng-container>
                        <ng-template #elseCredValidada>
                            
                            <mat-icon class="color-error mx-2" 
                                [ngClass]="{'cursor-pointer': iconMensaje}" 
                                [attr.title]="iconMensaje ? iconMensaje : null"
                            >
                                cancel
                            </mat-icon>
                        
                        </ng-template>
                    </ng-container>
                    
                    <ng-container *ngIf="validacionBtnGuardar(); else elseGuardar">
                        <button mat-flat-button 
                            class="custom-button-tertiary mx-2"
                            type="button"
                            (click)="onSubmit()"
                        >
                            <mat-icon 
                                aria-hidden="false" 
                                aria-label="Icono de Warning" 
                                fontIcon="save" 
                                class="icon-download pr-4 pb-4"
                            ></mat-icon>
                            Guardar Credenciales
                        </button>
                    </ng-container>
                    <ng-template #elseGuardar>
                        <button mat-flat-button 
                            class="custom-button-secondary mx-2"
                            type="button"
                            (click)="validaCredenciales()"
                        >
                            <mat-icon 
                                aria-hidden="false" 
                                aria-label="Icono de Warning" 
                                fontIcon="error" 
                                class="icon-download pr-4 pb-4"
                            ></mat-icon>
                            Validar Credenciales
                        </button>
                    </ng-template>
                </div>
            </ng-template>
            
        </div>

    </div>
</div>
